export default __webpack_public_path__ + "locales/es/DeleteDialog.json?hash=b5b48a3a306437edcf41a9dc4e598248";